import React from 'react';

import { BannerViewType } from '../../typings/pcode';
import { CreativePreview } from '../CreativePreview/CreativePreview';

export class ImageCreativePreview extends React.PureComponent<{
    previewUrl: string;
    width?: number;
    height?: number;
}> {
    render() {
        const { previewUrl, width, height } = this.props;
        const matchResult = previewUrl && previewUrl.match(/\/creatives\/(?:([a-f0-9]+)\/)?(\d+)\/preview/i);
        if (!matchResult) {
            return null;
        }

        const batchId = matchResult[1] || '';
        const creativeId = matchResult[2];

        return (
            <CreativePreview
                creativeId={creativeId}
                batchId={batchId}
                width={width}
                height={height}
                previewType={BannerViewType.adaptive0418}
                isSquareFormat={false}
                cspNonce={''}
            />
        );
    }
}
